// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module--form--1V2oa"};